import Sidemenu from '../components/base/sidemenu';
import UserManagementRedesign from '../components/user/UserManagementRedesign';
import { useSearchParams } from 'react-router-dom';

export default function UserPage() {
  const [searchParams, setSearchParams] = useSearchParams();

  const tab =
    searchParams.get('tab') === 'selectuser'
      ? 'selectuser'
      : 'alluser';

  const changeTab = (nextTab) => {
    const nextParams = new URLSearchParams(searchParams);

    nextParams.set('tab', nextTab);
    nextParams.set('page', '1');
    nextParams.delete('region');

    setSearchParams(nextParams);
  };

  return (
    <div className="flex user-management-layout">
      <Sidemenu />

      <main className="user-management-content">
        <UserManagementRedesign
          mode={tab}
          onChangeTab={changeTab}
        />
      </main>
    </div>
  );
}